'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const sections = [
  {
    title: 'Getting Started',
    links: [
      { label: 'Overview', href: '/docs' },
      { label: 'Quickstart', href: '/docs/quickstart' },
      { label: 'Use with Claude', href: '/docs/claude' },
      { label: 'Authentication', href: '/docs/authentication' },
    ],
  },
  {
    title: 'API Reference',
    links: [
      { label: 'All Endpoints', href: '/docs/api' },
      { label: 'Feature Requests', href: '/docs/feature-requests' },
      { label: 'Roadmap', href: '/docs/roadmap' },
    ],
  },
  {
    title: 'Advanced',
    links: [
      { label: 'Rate Limits', href: '/docs/rate-limits' },
      { label: 'Errors', href: '/docs/errors' },
    ],
  },
];

export default function DocsSidebar() {
  const pathname = usePathname();

  return (
    <aside className="hidden md:block w-60 shrink-0 border-r border-border/40 py-12 pr-6">
      <nav className="sticky top-24 space-y-8">
        {sections.map((section) => (
          <div key={section.title}>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground/60 mb-2 px-3">
              {section.title}
            </h4>
            <ul className="space-y-0.5">
              {section.links.map((link) => {
                const isActive = pathname === link.href;
                return (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className={`block text-sm px-3 py-1.5 rounded-md transition-colors ${
                        isActive
                          ? 'bg-primary/10 text-primary font-medium'
                          : 'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
